import axios from "axios";
import React from "react";
import Clearcart from "../components/clearcartbutton";
import Checkout from "../components/checkoutButton";
import '../styles/cart.css'
const loggedInUserID = parseInt(localStorage.getItem("loggedInUserID"));
export default class CartScreen extends React.Component {
   state = {
      posts: []
   }

   componentDidMount() {
      axios.get(`https://shoppee-clone.herokuapp.com/user/${loggedInUserID}/cartitem`)
         .then(res => {
            console.log(res.data)
            const posts = res.data;
            this.setState({ posts });
         })
   }

   render() {
      return (

         <div>
            <h2 className="carttitle">Your Cart <i class="bi bi-cart4"></i></h2>

            {this.state.posts.map(carts =>
               <div className="cartcard card-body p-3 mb-5 shadow-sm rounded">
                  <p className="h3">{carts.productname}<br/>
                  <img className="cartimg w-25 h-100 rounded " src={'images/' + carts.image} /> </p>
                  <p>Qty : {carts.qty}</p>
                  
               </div>)}
            <Checkout></Checkout>
            <Clearcart></Clearcart>
         </div>


      )
   }
}